import type { EquipmentAssignment, IEquipmentAssignmentInfo } from './equipment-assignment';
import type { EquipmentVehicle, IEquipmentVehicleInfo } from './equipment-vehicle';

declare function require(moduleId: string): unknown;

let assignmentModule: typeof import('./equipment-assignment') | undefined;
let vehicleModule: typeof import('./equipment-vehicle') | undefined;

function loadAssignmentModule(): typeof import('./equipment-assignment') {
  if (!assignmentModule) {
    assignmentModule = require('./equipment-assignment') as typeof import('./equipment-assignment');
  }
  return assignmentModule;
}

function loadVehicleModule(): typeof import('./equipment-vehicle') {
  if (!vehicleModule) {
    vehicleModule = require('./equipment-vehicle') as typeof import('./equipment-vehicle');
  }
  return vehicleModule;
}

export function instantiateEquipmentAssignment(info: IEquipmentAssignmentInfo): EquipmentAssignment {
  const mod = loadAssignmentModule();
  return mod.EquipmentAssignment.createInstance(mod.EquipmentAssignment, info);
}

/** Resolves EquipmentAssignment at runtime (avoids circular init with equipment-vehicle in providers). */
export function resolveEquipmentAssignmentClass(): typeof import('./equipment-assignment').EquipmentAssignment {
  return loadAssignmentModule().EquipmentAssignment;
}

export function instantiateEquipmentVehicle(info: IEquipmentVehicleInfo): EquipmentVehicle {
  const mod = loadVehicleModule();
  return new mod.EquipmentVehicle(info);
}
